MOVE.SearchHelper = (function (MOVE) {
  "use strict";
  var getVitalityFormattedRecentSearch =  function() {
    var recentSearches = MOVE.UserActivity.getSortedRecentSearches().splice(0,1);
    if( recentSearches.length > 0){
      var lastSearched = recentSearches[0];
      // we are reusing the autocomplete formatRecentSearches Method.
      // So to avoid the address framed with address we are deleting the nodes from query
      if(lastSearched.query.hasOwnProperty('address')){
        delete lastSearched.query.address;
        delete lastSearched.query.postal_code;
      }
      else if(lastSearched.query.hasOwnProperty('city') && lastSearched.query.hasOwnProperty('postal_code')){
        delete lastSearched.query.city;
        delete lastSearched.query.state_code;
      }
      return $.fn.autocomplete.formatRecentSearches(recentSearches)[0].location;
    }
    return null;
  };

  var getMortgageFormattedRecentSearch = function() {
    var recentSearches = MOVE.UserActivity.getSortedRecentSearches().splice(0,1);
    if( recentSearches.length > 0){
      var lastSearched = recentSearches[0];
      // we are reusing the autocomplete formatRecentSearches Method.
      // So to avoid the address framed with address we are deleting the nodes from query
      // Mortgage only supports city, zip & state_code.
      if (lastSearched.query.hasOwnProperty('county') && lastSearched.query.hasOwnProperty('city') && lastSearched.query.city.toLowerCase().indexOf("county") !== -1) {
        lastSearched.query = {};
      }
      else {
        $.each(lastSearched.query, function(k) {
          if (k !== 'city' && k !== 'state_code' && k !== 'postal_code') {
            delete lastSearched.query[k];
          }
        });
      }
      return $.fn.autocomplete.formatRecentSearches(recentSearches);
    }
    return null;
  };

   // The deaultLocation for vitality will be undefined.
   // Already there is code avilable in vitality js to use  ip sniff if recent search return null.
   // The deaultLocation for landerpages in cookie location or san fransico.
   var getRecentSearchedLocation = function (defaultLocation) {
     return MOVE.SearchHelper.getVitalityFormattedRecentSearch() || defaultLocation;
   };

   MOVE.SearchHelper = {
     getVitalityFormattedRecentSearch: getVitalityFormattedRecentSearch,
     getRecentSearchedLocation: getRecentSearchedLocation,
     getMortgageFormattedRecentSearch: getMortgageFormattedRecentSearch
   };

  return MOVE.SearchHelper;
}(MOVE || {}));



// WEBPACK FOOTER //
// ./shared_critical/search_helper.js